import {
    __,
    assoc,
    concat,
    contains,
    converge,
    compose,
    clone,
    head,
    flip,
    filter,
    map,
    of,
    ifElse,
    prop,
    propEq,
    replace,
    where,
    unnest,
    findIndex,
    isEmpty,
    last,
    split,
    forEach,
    drop
} from 'ramda';

import { notEmpty, mapIndexed, pickAs } from 'utils/ramdaAdditions';
import { isAncor } from 'utils/version';
import { formatDate, documentType } from './commonMapper';
import evolve from './evolve';
import { PROJECT_CLASSIFIER } from 'constants/classifiers';

const createSubgroup = compose(of, assoc('groupType', 'group'), pickAs({
    status: 'group'
}));

const isValidSubgroup = where({ sublist: notEmpty });

const getSubGroup = ifElse(isValidSubgroup, createSubgroup, () => []);

const setStatus = (group) => {
    const { name, subname } = group;
    return assoc('status', name + (subname ? '. ' + subname : ''), group);
};

const mapItems = mapIndexed(flip(assoc('number')));
const mapSubgroup = map(converge(concat, [ compose(getSubGroup, setStatus), compose(mapItems, prop('sublist')) ] ));
const mapGroup = map((group) => {
    return compose(unnest, mapSubgroup, prop('list'))(group);
});

const setGroupName = (items) => {
    return map(assoc('groupNameStatus', prop('group', head(items))), items);
};

const setSubGroupName = (group) => {
    return assoc('list', map(assoc('name', group.name), group.list), group);
};

const getItems = compose(unnest, map(setGroupName), mapGroup, map(setSubGroupName));

const feepercent = replace(/гонорар:\s|fee:\s/gi, '');

const moveClassifier = (data) => {
    if (!data.classifiers || isEmpty(data.classifiers)) {
        return data;
    }

    const statusIndex = findIndex(propEq('name', 'Status'), data.classifiers);
    if (statusIndex === -1) {
        return data;
    }

    const newData = clone(data);
    const newStatusClassifier = [];

    forEach((item) => {
        const classifierText = drop(1, split('/', item.text));
        return PROJECT_CLASSIFIER[classifierText[0]] ?
            newData[PROJECT_CLASSIFIER[classifierText[0]]] = last(classifierText) :
            newStatusClassifier.push(item)
    }, newData.classifiers[statusIndex]['classifier']);

    newData.classifiers[statusIndex]['classifier'] = newStatusClassifier;

    newData.education = newData.education_type ? `${newData.education_type} (${data.education})` : data.education;

    return newData;
};

const projectEvolve = evolve({
    feepercent: feepercent,
    closebefore: formatDate,
    prjstart: formatDate,
    lastchgdate: formatDate,
    execdate: formatDate,
    inworkdate: formatDate,
    deadline: formatDate,
    date: formatDate,
    documents: data => documentType(evolve({ date: formatDate })(data))
});

export const projectMapper = data => {
    if (isAncor() && data.participantsDetailed) {
        data.coexecutors = filter(propEq('role', 2), data.participantsDetailed);
        data.participantsDetailed = map(item => assoc('text', `${item.roleName} - ${item.text}`, item), data.participantsDetailed);
        data.participants = filter(compose(contains(__, [1, 2]), prop('role')), data.participantsDetailed);
    }

    if (isAncor()) {
        data = moveClassifier(data);
    }

    return projectEvolve(data);
};

export default (data) => {
    const { projects, ...evolvedData } = evolve({
        projects: {
            list: {
                sublist: projectMapper
            }
        }
    })(data);

    return {
        ...evolvedData,
        projects: getItems(projects || [])
    };
}
